import api from "./api";

export const getCitiesByCountry = ({ queryKey }) => {
  const [_key, { country }] = queryKey;
  
  if (!country) {
    throw new Error("Country code is required");
  }
  
  return api.get(`/countries/${country}/cities`);
};

export const getCitiesByCountryDirect = async (country) => {
  if (!country) {
    throw new Error("Country code is required");
  }
  
  try {
    const response = await api.get(`/countries/${country}/cities`);
    return response.data;
  } catch (error) {
    console.error(`Failed to fetch cities for ${country}:`, error);
    throw error;
  }
};